import React from 'react';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';
import scheduleFormStyles from '../../../stylesheets/management_site/scheduleForm.module.scss';
import classNames from 'classnames';

const ScheduleDueDateSettings = ({
  fieldPrefix,
  initialData,
  dueDateType,
  setDueDateType,
  parsedDueDate = null,
}) => {
  const parsedDueDateType = parsedDueDate?.type;

  return (
    <div className={newLeaseModalStyles.scheduleDueDateSection}>
      <div className={newLeaseModalStyles.sectionHeader}>
        <h3 className={newLeaseModalStyles.sectionTitle}>Due Date</h3>
      </div>
      <div className={newLeaseModalStyles.sectionContent}>
        <div
          id="charge-field-due-date"
          className={classNames(
            'pm-flex',
            'pm-flex-col',
            newLeaseModalStyles.noMarginBottom
          )}
        >
          <div
            className={classNames(
              'pm-flex',
              'pm-align-center',
              'pm-margin-bottom-10',
              'pm-form-multi',
              scheduleFormStyles.radioOptionGap,
              {
                [scheduleFormStyles.selected]: dueDateType === 'relative',
                [scheduleFormStyles.notSelected]: dueDateType !== 'relative',
              }
            )}
          >
            <div className="mdc-form-field">
              <div className="mdc-radio">
                <input
                  type="radio"
                  className="mdc-radio__native-control"
                  name={`${fieldPrefix}[due_date_type]`}
                  value="relative"
                  checked={dueDateType === 'relative'}
                  onChange={() => setDueDateType('relative')}
                />
                <div className="mdc-radio__background">
                  <div className="mdc-radio__outer-circle"></div>
                  <div className="mdc-radio__inner-circle"></div>
                </div>
              </div>
            </div>
            <div
              className={classNames(
                'mdc-form-field',
                'mdc-form-field--align-end',
                scheduleFormStyles.frequencySelectContainer
              )}
            >
              <div
                data-mdc-auto-init="MDCTextField"
                className={classNames(
                  'mdc-text-field',
                  'pm-large',
                  scheduleFormStyles.scheduleTextInput
                )}
              >
                <input
                  type="text"
                  id="due-date-type-field-1"
                  className="mdc-text-field__input due-date-type-field"
                  name={`${fieldPrefix}[template_transaction_attributes][days_for_payment]`}
                  defaultValue={
                    parsedDueDateType === 'offset'
                      ? parsedDueDate.offsetDays?.toString()
                      : initialData.daysForPayment
                  }
                  disabled={dueDateType !== 'relative'}
                />
                <label
                  htmlFor="due-date-type-field-1"
                  className="mdc-floating-label"
                >
                  Days from scheduled charge
                </label>
              </div>
            </div>
          </div>

          <div
            className={classNames(
              'pm-flex',
              'pm-align-center',
              'pm-margin-bottom-10',
              'pm-form-multi',
              scheduleFormStyles.radioOptionGap,
              {
                [scheduleFormStyles.selected]: dueDateType === 'fixed',
                [scheduleFormStyles.notSelected]: dueDateType !== 'fixed',
              }
            )}
          >
            <div className="mdc-form-field">
              <div className="mdc-radio">
                <input
                  type="radio"
                  className="mdc-radio__native-control"
                  name={`${fieldPrefix}[due_date_type]`}
                  value="fixed"
                  checked={dueDateType === 'fixed'}
                  onChange={() => setDueDateType('fixed')}
                />
                <div className="mdc-radio__background">
                  <div className="mdc-radio__outer-circle"></div>
                  <div className="mdc-radio__inner-circle"></div>
                </div>
              </div>
            </div>
            <div
              className={classNames(
                'mdc-form-field',
                'mdc-form-field--align-end',
                scheduleFormStyles.frequencySelectContainer
              )}
            >
              <div
                className={classNames(
                  'pm-select',
                  'pm-relative',
                  'pm-selectlabel',
                  scheduleFormStyles.fixedDaySelect
                )}
              >
                <label className="pm-selectlabel-text">
                  Fixed day of month
                </label>
                <select
                  id="due-date-type-field-2"
                  className={classNames(
                    'pm-default-select2-menu',
                    'mdc-select',
                    'pm-select-medium',
                    'due-date-type-field'
                  )}
                  name={`${fieldPrefix}[template_transaction_attributes][due_date]`}
                  defaultValue={
                    parsedDueDateType === 'fixedDay' && parsedDueDate.dayOfMonth
                      ? (() => {
                          const tempDate = new Date();
                          tempDate.setDate(parsedDueDate.dayOfMonth);
                          return tempDate.toISOString().slice(0, 10);
                        })()
                      : initialData.dueDate
                  }
                  disabled={dueDateType !== 'fixed'}
                >
                  {Array.from({ length: 28 }, (_, i) => {
                    const d = new Date();
                    d.setDate(i + 1);
                    const iso = d.toISOString().slice(0, 10);
                    return (
                      <option key={i + 1} value={iso}>
                        {i + 1}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          <div
            className={classNames('pm-flex', 'pm-align-center', {
              [scheduleFormStyles.selected]: dueDateType === 'end of month',
              [scheduleFormStyles.notSelected]: dueDateType !== 'end of month',
            })}
          >
            <div className="mdc-form-field">
              <div className="mdc-radio">
                <input
                  type="radio"
                  className="mdc-radio__native-control"
                  name={`${fieldPrefix}[due_date_type]`}
                  value="end of month"
                  checked={dueDateType === 'end of month'}
                  onChange={() => setDueDateType('end of month')}
                />
                <div className="mdc-radio__background">
                  <div className="mdc-radio__outer-circle"></div>
                  <div className="mdc-radio__inner-circle"></div>
                </div>
              </div>
              <label>End of month</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleDueDateSettings;
